module.exports = __webpack_public_path__ + "static/media/angular.a4bff3f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/angular.png
// module id = 65
// module chunks = 0